export const appversion = { build : "3.1.2400" };
